import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  HStack,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import { successSteps } from "../../constants/successSteps";
import { useContaxt } from "../../context/Context";
import image from "../../images/webdesign_vertriebler_david.webp";
import { ActionButton } from "../ActionButton";
import { HeadLine } from "../HeadLine";
import { Reveal } from "../Reveal";

export function Success({ componentRef }) {
  const { paddingX, marginTop, variant } = useContaxt();

  const Content = () => {
    return (
      <Stack spacing={5}>
        {successSteps.map((info, i) => {
          return (
            <Box key={i}>
              <Reveal direction="up" delay={i * 0.06}>
                <Card
                  w={["90vw", "90vw", "70vw", 600, 650]}
                  boxShadow="2xl"
                  p="6"
                  rounded="md"
                  bg="white"
                  _hover={{ bg: "black", color: "white" }}
                >
                  <CardHeader pt={"10px"}>
                    <Stack direction={variant === "base" ? "column" : "row"}>
                      <Center>{info.icon}</Center>
                      <Text
                        fontSize={"20px"}
                        fontWeight={"bold"}
                        pl={"10px"}
                        textAlign={"center"}
                      >
                        {" "}
                        {info.title}
                      </Text>
                    </Stack>
                  </CardHeader>
                  <CardBody mt={"-30px"}>
                    <Text
                      pl={variant === "base" ? "0px" : "50px"}
                      textAlign={variant === "base" ? "center" : "left"}
                    >
                      {info.text}
                    </Text>
                  </CardBody>
                </Card>
              </Reveal>
            </Box>
          );
        })}
      </Stack>
    );
  };

  const ImageBox = () => {
    return (
      <Image
        src={image}
        w={["90vw", "90vw", "70vw", "16.7vw"]}
        minW={["300px", "300px", "300px", "300px"]}
        aspectRatio={2 / 3}
        maxH={"60vh"}
        objectFit="cover"
        alt={
          "Der Webdesign Vertriebler David bespricht ein aktuelles Webdesign Projekt mit einem Kunden am Telefon"
        }
        mb={"20px"}
        borderRadius={"25px"}
        title="Webdesign besprechung mit einem Kunden"
      ></Image>
    );
  };

  return (
    <Box w={"100%"} id={"success"} ref={componentRef}>
      <Reveal direction="up" amount={0.2}>
        <HeadLine
          as="h1"
          text={
            <Text>
              Unsere <b>Vorgehensweise</b> für deinen persönlichen <b>Erfolg</b>
            </Text>
          }
        />
      </Reveal>
      <Center w={"100%"} mt={marginTop}>
        {variant === "lg" ? (
          <HStack spacing={10} px={paddingX}>
            <Stack>
              <Reveal direction="up" delay={0.05}>
                <ImageBox />
              </Reveal>
              <Reveal direction="up" delay={0.1}>
                <ActionButton />
              </Reveal>
            </Stack>
            <Content />
          </HStack>
        ) : (
          <Stack spacing={5} px={paddingX}>
            <Reveal direction="up" delay={0.05}>
              <ImageBox />
            </Reveal>
            <Stack spacing={5}>
              <Content />
              <Center>
                <Reveal direction="up" delay={0.1}>
                  <ActionButton />
                </Reveal>
              </Center>
            </Stack>
          </Stack>
        )}
      </Center>
    </Box>
  );
}
